import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrayGroup from '../../components/array-group/array-group';
import useTitle from '../../hooks/useTitle';
import { ToastContext } from '../../providers/Toast.provider';
import { createRecipe } from './services/create-recipe.service';

export function RecipeCreatorView() {
    const [recipe, setRecipe] = useState({
        title: '',
        description: '',
        image: '/files/default_recipe.jpg',
        ingredients: [],
        instructions: [],
        tags: [],
    });
    const navigate = useNavigate();
    const { createToast } = useContext(ToastContext);
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        setIsValid(textValidator(recipe.title));
    }, [recipe]);


    useTitle('Crear Receta');

    function textValidator(value) {
        return value.trim().length > 0;
    }

    function handleChange(key, value) {
        setRecipe({ ...recipe, [key]: value });
    }

    function handleImageChange(ev) {
        const fileReader = new FileReader();
        const file = ev.target.files[0];
        fileReader.addEventListener('load', () => {
            setRecipe({
                ...recipe, image: {
                    data: fileReader.result,
                    file: file,
                }
            });
        });
        fileReader.readAsDataURL(file);
    }

    function handleReoderIn(key, event) {
        setRecipe((oldValue) => {
            const oldPosition = oldValue[key].findIndex(v => v === event.text);
            const keyNewValue = [...oldValue[key]];
            const newValue = {
                ...oldValue,
                [key]: [...keyNewValue.slice(0, oldPosition), ...keyNewValue.slice(oldPosition + 1)],
            }

            if (event.targetPosition === -1) {
                event.targetPosition = 0;
            }

            newValue[key].splice(event.targetPosition, 0, event.text);

            return newValue;
        });
    }

    function handleEditIn(key, modification) {
        let newValue = [...recipe[key]];

        switch (modification.type) {
            case 'new':
                newValue = [...newValue, modification.text];
                break;
            case 'textChange':
                newValue[modification.index] = modification.text;
                break;
            case 'remove':
                newValue = [...newValue.filter((_, ind) => ind !== modification.index)];
                break;
            default:
        }
        setRecipe({ ...recipe, [key]: newValue });
    }

    function handleSave(ev) {
        ev.preventDefault();

        const formData = new FormData();
        formData.append('title', recipe.title);
        formData.append('description', recipe.description);
        formData.append('ingredients', JSON.stringify(recipe.ingredients));
        formData.append('instructions', JSON.stringify(recipe.instructions));
        formData.append('tags', JSON.stringify(recipe.tags));
        if (typeof (recipe.image) === 'object' && recipe.image.hasOwnProperty('file')) {
            formData.append('image', recipe.image.file);
        }

        createRecipe(formData)
            .then(response => {
                if (response.message === 'Created') {
                    createToast({ type: 'success', text: 'Receta creada, redireccionando...', ttl: 1500 });
                    setIsValid(false);
                    setTimeout(() => {
                        navigate(-1, { replace: true });
                    }, 1500);
                } else {
                    createToast({ type: 'error', text: 'No se pudo procesar la respuesta del servidor.', ttl: 3000 });
                }
            })
            .catch(err => {
                createToast({ type: 'error', text: 'Ups! Ocurrió un error y no pudimos crear la receta.', ttl: 3000 });
                console.error(err);
            });
    }


    return (
        <>
            <form className="edit-recipe-form">
                <div className="input-group">
                    <label htmlFor="title">Título</label>
                    <input
                        id="title"
                        className="input-text"
                        type="text"
                        placeholder="Título de la receta"
                        value={recipe.title}
                        onChange={(ev) => handleChange('title', ev.nativeEvent.target.value)}
                    />
                </div>

                <div className="input-group">
                    <label htmlFor="description">Descripción</label>
                    <input
                        id="description"
                        className="input-text"
                        type="text"
                        placeholder="Descripción de la receta"
                        value={recipe.description}
                        onChange={(ev) => handleChange('description', ev.nativeEvent.target.value)}
                    />
                </div>

                <div className="input-group">
                    <label htmlFor="imagen">Imagen</label>
                    <div className="input-group-image">
                        <img className="input-image" src={recipe.image?.data || recipe.image} alt="Recipe" />
                        <input
                            id="imagen"
                            className="input-text"
                            type="file"
                            accept="image/jpg,image/png,image/jpeg"
                            onChange={(ev) => handleImageChange(ev.nativeEvent)}
                        />
                    </div>
                </div>

                <div className="input-group">
                    <label>Ingredientes</label>
                    <ArrayGroup
                        items={recipe.ingredients}
                        handleModification={(ev) => handleEditIn('ingredients', ev)}
                        handleReorder={(ev) => handleReoderIn('ingredients', ev)}
                        validators={[textValidator]} />
                </div>

                <div className="input-group">
                    <label>Instrucciones</label>
                    <ArrayGroup
                        items={recipe.instructions}
                        handleModification={(ev) => handleEditIn('instructions', ev)}
                        handleReorder={(ev) => handleReoderIn('instructions', ev)}
                        validators={[textValidator]} />
                </div>

                <div className="input-group">
                    <label>Etiquetas</label>
                    <ArrayGroup
                        items={recipe.tags}
                        handleModification={(ev) => handleEditIn('tags', ev)}
                        handleReorder={(ev) => handleReoderIn('instructions', ev)}
                        validators={[textValidator]} />
                </div>

                <div className="input-group">
                    <button className={`btn ${isValid ? 'btn--valid' : 'btn--danger'}`} onClick={handleSave} disabled={!isValid}>Crear receta</button>
                </div>

            </form>
        </>
    );
}
